import { useState, useCallback } from "react";
import { useSelectionContainer, boxesIntersect } from "@air/react-drag-to-select";
import { TOP_EDGE } from "../constants";
import { DESELECT_ACTION, DESELECT_ALL_ACTION, SELECT_ACTION, SELECT_ALL_ACTION } from "./useCanvasReducer";


/**
 * Methods related to card selection
 */

export default ({
  cards, //
  dispatch,
  groups,
  cardIdsString,
  isSpaceDragging,
  zoom,
  position,
  flushSelectionCache,
  selectedCardIds,
}) => {
  const [isDraggingSelection, setIsDraggingSelection] = useState(false);

  /**
   * Selects all the cards
   */
  const selectAllCards = useCallback(() => {
    dispatch({ type: SELECT_ALL_ACTION });
    // setCards((draft) => {
    //   Object.keys(draft).forEach((id) => {
    //     selectCard(draft, id);
    //   });
    // });
    flushSelectionCache();
  }, [cardIdsString, groups]);

  /** Deselects all cards except for the `exceptId` */
  const deselectAllCards = useCallback(
    ({ exceptId = null } = {}) => {
      // console.log("deselect all cards");

      if (!isDraggingSelection) {
        // do not deselect if currently dragging a selection

        dispatch({ type: DESELECT_ALL_ACTION });
        if (exceptId) {
          dispatch({ type: SELECT_ACTION, id: exceptId });
        }

        flushSelectionCache();
      }
    },
    [isDraggingSelection, cardIdsString, selectedCardIds, groups]
  );

  /**
   * Selects an addition card specified by id
   */
  const selectAdditionalCard = useCallback(
    ({ id }) => {
      console.log("select additional card");
      // setCards((draft) => {
      //   selectCard(draft, id);
      // });

      dispatch({ type: SELECT_ACTION, id: id });

      flushSelectionCache();
    },
    [cardIdsString, selectedCardIds, groups]
  );

  const globalToCanvasCoordinates = (box) => {
    return {
      top: (box.top - TOP_EDGE) * (1 / zoom) + position.y,
      left: box.left * (1 / zoom) + position.x,
      width: box.width * (1 / zoom),
      height: box.height * (1 / zoom),
    };
  };

  // Handles the drag selection logic
  const { DragSelection } = useSelectionContainer({
    isEnabled: !isSpaceDragging,
    onSelectionStart: () => {
      // console.log("onSelectionStart");
      if (!isDraggingSelection) {
        setIsDraggingSelection(true);
      }
    },
    onSelectionEnd: () => {
      // console.log("onSelectionEnd");
      if (isDraggingSelection) {
        setIsDraggingSelection(false);
      }
    },
    onSelectionChange: (box) => {
      // do nothing if box is zero width/height
      if (box.width === 0 && box.height === 0) {
        return;
      }

      // guard against null cards (TODO: not sure how this could happen)
      if (!cards) {
        return;
      }

      // iterate across all cards and see if it intersects
      Object.keys(cards).forEach((id) => {
        const card = cards[id];

        const cardBox = {
          top: card.y,
          left: card.x,
          width: card.width,
          height: card.height,
        };

        const selectionBox = globalToCanvasCoordinates(box);

        // TODO: should batch this into one update call
        if (boxesIntersect(selectionBox, cardBox)) {
          if (!cards[id].selected) {
            dispatch({ type: SELECT_ACTION, id: id });

            flushSelectionCache();
          }
        } else {
          if (cards[id].selected) {

            dispatch({ type: DESELECT_ACTION, id: id });
            flushSelectionCache();
          }
        }
      });
    },
    selectionProps: {
      style: {
        borderRadius: 4,
        opacity: 0.5,
        zIndex: "999999",
        position: "relative",
      },
    },
    shouldStartSelecting: (target) => {
      /** if dragging on top SVG element that holds arrows, we allow it */
      if (target instanceof SVGElement) {
        return true;
      }

      /**
       * prevent selection dragging when mouse down occurs on a card
       * uses data-disableselect attribute
       */
      if (target instanceof HTMLElement) {
        let el = target;
        while (el.parentElement && !el.dataset.disableselect) {
          el = el.parentElement;
        }
        return el.dataset.disableselect !== "true";
      }

      /**
       * If the target doesn't exist, return false
       * This would most likely not happen. It's really a TS safety check
       */
      return false;
    },
  });

  return {
    selectAllCards,
    deselectAllCards,
    selectAdditionalCard,
    DragSelection,
    isDraggingSelection,
  };
};
